import axios from 'axios'
let baseURL = '/api'
import { message } from 'ant-design-vue'
import { getToken, setToken, removeToken, removeSignKey } from '@/utils/auth'
import { router } from '@/router/index'
import { attachSignHeaders, clearLoginSign } from '@/utils/sign'
const service = axios.create({
    withCredentials: true,
    crossDomain: true,
    baseURL,
    timeout: 6000
})

const whiteUrl = [
    '/admin/auth/login/xcode',
    '/admin/auth/xlogin',
    '/admin/auth/wxcp/loginState',
    '/admin/auth/wxcp/doLogin'
  ]

// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
    config => {
        if (! (whiteUrl.indexOf(config.url) > -1)) {
            config.headers['Authorization'] = getToken()
          }
        // 接口请求签名：每次请求前重新生成 Timestamp/Nonce/Sign（登录阶段带 Login-Ticket）
        attachSignHeaders(config)
        return config;
    },
    error => {
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

//配置成功后的拦截器
service.interceptors.response.use(async res => {
    console.log(res, '@@@@@----------------');
    if (res.status == 200) {
        let { code } = res.data
        if (code == '0') return res.data.data
        // #ifndef H5
        else if (code == '1100002') {
            removeToken()
            removeSignKey()
            clearLoginSign()
            router.push('/login')
            return Promise.reject(res)
        } else if (code == 10005) {
            // let token = await refreshLogin()
            // res.config.headers.Authorization = token
            router.replace('/login')
        } else {
            return Promise.reject(res)
        }
    } else {
        return Promise.reject(res);
    }
}, error => {
    return Promise.reject(error)
})


async function http (praram) {
    try {
        let res = await service(praram)
        return res
    } catch (error) {
        message.error(error.data.message || '系统异常')
        return Promise.reject()
    }
}

export {
    http,
    service
}